// forum.js
export default {
    forum_name: 'Forum name',
    search: 'Search',
    reset: 'Reset',
    create_forum: 'Create a forum',
    serial_number: 'Serial number',
    forum_name_again: 'Forum name',
    status: 'Status',
    start_time_to_end_time: 'Start - end time',
    founder: 'Founder',
    operation: 'Operation',
    manage: 'Manage',
    edit: 'Edit',
    delete: 'Delete',
    prompt: 'Prompt',
    confirm_delete_forum: 'Are you sure you want to delete this forum?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    delete_success: 'Delete successful',
    operation_success: 'Operation successful',
    edit_forum: 'Edit forum',
    basic_info: 'Basic information',
    forum_english_name: 'Forum English name',
    start_time: 'Start time',
    belonging_area: 'Belonging area',
    detailed_address: 'Detailed address',
    cover_image: 'Cover image',
    upload_image: 'Upload image',
    introduction: 'Introduction',
    please_input_forum_name: 'Please enter the forum name',
    please_input_forum_english_name: 'Please enter the forum English name',
    please_select_start_time: 'Please select the start time',
    please_input_detailed_address: 'Please enter the detailed address',
    please_upload_cover_image: 'Please upload the cover image',
    please_input_introduction: 'Please enter the introduction',
    you_can_only_upload_image_files: 'You can only upload image files',
    end: 'Ended',
    doing: 'In progress',
    please_input_forum_id: 'Please enter the forum ID',
    status_on: 'On',
    status_off: 'Off',
    forumLink: 'Registration link'
};
